
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 9.875V2m-4.375 8.75h-1.75a.875.875 0 00-.875.875v3.5a.875.875 0 00.875.875h12.25a.875.875 0 00.875-.875v-3.5a.875.875 0 00-.875-.875h-1.75M12.5 6.375L9 10.75 5.5 6.375","stroke":"currentColor","stroke-width":"1.75","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    